import React, { useEffect } from "react";

function HubspotOnboarding() {
  useEffect(() => {
    window.location.href = `https://${process.env.REACT_APP_V2_PATH}/integrations/crm/hubspot/setup`;
  }, []);

  return null;
}

export default HubspotOnboarding;
